import {Injectable} from '@angular/core';
import {ConnectionBackend, Headers, Http, RequestOptions, RequestOptionsArgs, Response} from '@angular/http';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {Observable} from 'rxjs/Observable';
import {Utilities as U} from '../utilities/utilities.model';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';
import {AccessReference} from '@shared/models/access-reference.model';
import {LoginRequestService} from '@shared/service/login-request.service';
import {catchError, switchMap, tap} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {UserPermissionsModel} from '@shared/models/user-permission.model';
import {SuperUserPermissions} from '../../permissions-variables';
import { CommoditiesUtilityService } from './commodities-utility.service';

export enum ExternalReferral {
	MYALD = 'myald', // da my ald
	EXTERNAL_ALD = 'external', // affidatari o chiunque abbia il link di accesso per gli allegati
}
@Injectable()
export class HttpAuthService extends Http {
	isSuperUser: boolean = false;
    //loggedUser:UserPermissionsModel;
	private static MYALD = 'myald';
    environment: AppConfigEnvironment;


	private externalLoginMap: Map<string, { username: string, password: string }> = new Map([
		[ExternalReferral.MYALD, {
			username: LoginRequestService.env.MYALD_USER_NAME,
			password: LoginRequestService.env.MYALD_USER_PASSWORD
		}],
		[undefined, {
			username: LoginRequestService.env.SYSTEM_USER_NAME,
			password: LoginRequestService.env.SYTEM_USER_PASSWORD
		}],
	]);

    constructor(_backend: ConnectionBackend,
        _defaultOptions: RequestOptions,
        public location: Location,
        public loginRequest: LoginRequestService,
        public router: Router,
        private appConfig: AppConfigEnvironmentService,
        private commoditiesUtilityService:CommoditiesUtilityService) {
        super(_backend, _defaultOptions);
        this.environment = appConfig.Environment;
    }

    superGet(mUrl: string, options?: RequestOptionsArgs): Observable<Response> {
        return super.get(mUrl, options);
    }

    superDelete(mUrl: string, options?: RequestOptionsArgs): Observable<Response> {
        return super.delete(mUrl, options);
    }

    superPost(mUrl: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
        return super.post(mUrl, body, options);
    }

    superPut(mUrl: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
        return super.put(mUrl, body, options);
    }

    superPatch(mUrl: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
        return super.patch(mUrl, body, options);
    }

    setOptionsForNewGW(accessReference: AccessReference, options?: RequestOptionsArgs, isDelivery: boolean = false): RequestOptionsArgs {
        if (!U.isVoid(options)) {
            if (U.isVoid(options.headers)) {
                options.headers = new Headers();
            }
            if (options.headers.get('authToken')) {
                options.headers.delete('authToken');
            }
            const bearer: string = 'Bearer ' + accessReference.access_token;
            if (options.headers.get('Authorization')) {
                options.headers.delete('Authorization');
            }
            options.headers.append('Authorization', bearer);
        } else {
            options = new RequestOptions();
            const bearer: string = 'Bearer ' + accessReference.access_token;
            options.headers = new Headers();
            options.headers.append('Authorization', bearer);
            options.headers.append('apikey', U.APPCONFIGENVIRONMENT.apiKey);
        }
        return options;
    }

    get(mUrl: string, redirectUrl: string, options?: RequestOptionsArgs, isFirstRequest?: boolean): Observable<Response> {
        let isInfocert = false;
        if (mUrl.indexOf(this.environment.ENTRY_POINT_INFOCERT_DOCUMENTS) === 0) {
            isInfocert = true;
        }
        const accessToken   = U.extractParameter(this.location, 'access_token');
	    const tokenMetadata = U.extractParameter(this.location, 'token_metadata');
        let accessReference = U.getAccessReference();

        // Viene passato this.environment.ROOT_REDIRECT
        redirectUrl = encodeURIComponent(redirectUrl);
        
        // $code è il JWT access_token, preso dal redirect dopo il login di leasplane
        // const code = U.extractParameter(this.location, 'code');
        const code = ((): string => {

            // bisogna fare una funzione dedicata
            // il nuovo login prende l'URL di redirect senza #
            // non è compliant con il routing di Angular

            let url = '';
            url = window.location.href;
            url = url.slice(this.environment.APP_ROOT.length, url.length);
            
            const criteria = '?code=';
            return url.includes(criteria) ? url.slice(url.indexOf(criteria)+criteria.length, url.length) : '';
        })();

        if (accessReference && isFirstRequest) {
            /* logout forzato nel caso sia già presente accessReference nel localStorage */
            if (
                (!U.isEmpty(accessToken) || !U.isEmpty(tokenMetadata) || !U.isEmpty(code))  && 
                accessToken !== accessReference.access_token
            ) {
                LoginRequestService.deleteAccessReference();
                accessReference = U.getAccessReference();
            }
        }

        if (accessReference) {

            // Sono già loggato
            // NON È FLUSSO PUBBLICO

            if (!isInfocert) {
                options = this.setOptionsForNewGW(accessReference, options);
            }
            return this.handleResponse(new GetRequest(this, mUrl), redirectUrl, options, isInfocert);

        } else if (code) {
            
            // OAM Login - STEP 2 / Redirect
            // Gestiamo il redirect a noi, da parte di OAM, e prendiamo l'auth_code
            // Abbiamo preso l'auth_code dal redirect di OAM
            
            // In questo punto ci entriamo subito dopo il login
            // dopo il redirect da parte di OAM
            // è la prima chiamata che fa l'applicazione

            return new Observable<Response>(
                observer => {
                    // Richiesta token accessReference per il primo login dell'APP
                    this.loginRequest.loginTokensRequestOAM(redirectUrl, code).subscribe(resp => {
                            const response = resp as Response;
                            if (response && response.ok) {
                                //options = this.setOptionsForNewGW(accessReference, options);
                                //Response OK login-service setted accessReference
                                //make normal request because sure to have token
                                options = U.updateOptions(options);
                                super.get(mUrl, options).subscribe(
                                    (res) => {
                                        /*
                                        setTimeout(() => {
                                            localStorage.setItem(U.NEW_LOGIN, U.NEW_LOGIN);
                                            let currentRoute = localStorage.getItem(U.CURRENT_ROUTE);
                                            localStorage.removeItem(U.CURRENT_ROUTE);
                                        }, 50);
                                        */
                                        observer.next(res);
                                        observer.complete();
                                    }, error => {//response KO
                                        observer.next(error);
                                        observer.complete();
                                    }
                                );
                            } else {

                                // Flusso PRE-LOGIN
                                // solo quando si è fuori dall'app, poi viene fatto il redirect verso il login

                                //response KO
                                //TODO management other error
                                this.handleError(response ? response.statusText : '');
                                this.loginRequest.loginCodeRequest(redirectUrl);
                            }
                        });
                });

        } else if (accessToken) {

            // Sembra che questo giro sia inutile, flusso pubblico prende $token_metadata nell'URL

            /* login flusso pubblico e da myald */
	        /* scusatemi ma è un flusso non standard imposto dall'alto, chiedo perdono */
            // l'accessToken è preso dall'URL del redirect della pagina statica claims_public.html

            const referral: string = U.extractParameter(this.location, 'referral');
            /* get metadata from Auth before request new accessReference */
            const sessionMetadataToken = U.extractParameter(this.location, 'sessionmetadata_token');
            const refreshToken = U.extractParameter(this.location, 'refresh_token');
            this.loginRequest.setMetadataFromAuth(sessionMetadataToken, refreshToken, accessToken).subscribe((resp: any) => {
                if (!U.isVoid(resp)) {
                    if (!resp.ok) {
                        this.handleError(resp.statusText);
                    }
                }
            });
            /* request new valid accessReference for the current client_id */
            return new Observable<Response>(
                observer => {
                    this.loginRequest.loginPasswordTokenRequest(this.externalLoginMap.get(referral).username, this.externalLoginMap.get(referral).password).subscribe(
                        resp => {
                            if (resp.ok) {
                                options = U.updateOptions(options);
                                super.get(mUrl, options).subscribe(
                                    (res) => {
                                        /*
                                        setTimeout(() => {
                                            localStorage.setItem(U.NEW_LOGIN, U.NEW_LOGIN);
                                            let currentRoute = localStorage.getItem(U.CURRENT_ROUTE);
                                            localStorage.removeItem(U.CURRENT_ROUTE);
                                        }, 50);
                                        */
                                        observer.next(res);
                                        observer.complete();
                                    }, error => {//response KO
                                        observer.next(error);
                                    }
                                );
                            } else {
                                this.loginRequest.loginCodeRequest(redirectUrl);
                            }
                        });
                }
            );
        } else if (tokenMetadata) {

            // IL LOGIN DI FLUSSO PUBBLICO PORTA QUÌ
			return this.externalLoginFromTokenMetadata(tokenMetadata, mUrl, redirectUrl, options);
        } else {
            
            //not access-reference (no token) and not have the code from login page
            //not accessed so redirect to login page
            return new Observable<any>(observer => {
                this.loginRequest.loginCodeRequest(redirectUrl);
                observer.next(null);
            });
        }
    }

    post(mUrl: string, body: any, redirectUrl: string, options?: RequestOptionsArgs): Observable<Response> {
        let isInfocert = false;
        if (mUrl.indexOf(this.environment.ENTRY_POINT_INFOCERT_DOCUMENTS) === 0) {
            isInfocert = true;
        }
        const accessReference = U.getAccessReference();
        // options = this.setOptionsForNewGW(accessReference, options);
        redirectUrl = encodeURIComponent(redirectUrl);
        if (accessReference) {
            if (this.environment.environment === 'aaa') {
                const isDelivery = mUrl.indexOf(this.environment.GW_API) === 0;
                options = this.setOptionsForNewGW(accessReference, options, isDelivery);
            } else {
                options = this.setOptionsForNewGW(accessReference, options);
            }
            //have access_token
            //make normal request
            //console.log(accessReference);
            if (mUrl.indexOf(this.environment.GW_API) > -1 && !U.isVoid(options)) {
                options.headers.set(U.SESSION_ID, U.getSessionID());
                //console.log('session_id', U.getSessionID());
            }
            return this.handleResponse(new PostRequest(this, mUrl, body), redirectUrl, options, isInfocert);
        } else {
            //not access-reference (no token) and not have the code from login page
            //not accessed so redirect to login page
            this.loginRequest.loginCodeRequest(redirectUrl);
        }
    }

    put(mUrl: string, body: any, redirectUrl: string, options?: RequestOptionsArgs): Observable<Response> {
        let isInfocert = false;
        if (mUrl.indexOf(this.environment.ENTRY_POINT_INFOCERT_DOCUMENTS) === 0) {
            isInfocert = true;
        }
        const accessReference = U.getAccessReference();
        // options = this.setOptionsForNewGW(accessReference, options);
        redirectUrl = encodeURIComponent(redirectUrl);
        if (accessReference) {
            if (this.environment.environment === 'aaa') {
                const isDelivery = mUrl.indexOf(this.environment.GW_API) === 0;
                options = this.setOptionsForNewGW(accessReference, options, isDelivery);
            } else {
                options = this.setOptionsForNewGW(accessReference, options);
            }
            //have access_token
            //make normal request
            //console.log(accessReference);
            return this.handleResponse(new PutRequest(this, mUrl, body), redirectUrl, options, isInfocert);
        } else {
            //not access-reference (no token) and not have the code from login page
            //not accessed so redirect to login page
            this.loginRequest.loginCodeRequest(redirectUrl);
        }
    }

    patch(mUrl: string, body: any, redirectUrl: string, options?: RequestOptionsArgs): Observable<Response> {
        let isInfocert = false;
        if (mUrl.indexOf(this.environment.ENTRY_POINT_INFOCERT_DOCUMENTS) === 0) {
            isInfocert = true;
        }
        const accessReference = U.getAccessReference();
        // options = this.setOptionsForNewGW(accessReference, options);
        const redirectUri: string = encodeURIComponent(redirectUrl);
        if (accessReference) {
            if (this.environment.environment === 'aaa') {
                const isDelivery = mUrl.indexOf(this.environment.GW_API) === 0;
                options = this.setOptionsForNewGW(accessReference, options, isDelivery);
            } else {
                options = this.setOptionsForNewGW(accessReference, options);
            }
            //have access_token
            //make normal request
            //console.log(accessReference);
            return this.handleResponse(new PatchRequest(this, mUrl, body), redirectUri, options, isInfocert);
        } else {
            //not access-reference (no token) and not have the code from login page
            //not accessed so redirect to login page
            this.loginRequest.loginCodeRequest(redirectUri);
        }
    }

    delete(mUrl: string, redirectUrl: string, options?: RequestOptionsArgs): Observable<Response> {
        let isInfocert = false;
        if (mUrl.indexOf(this.environment.ENTRY_POINT_INFOCERT_DOCUMENTS) === 0) {
            isInfocert = true;
        }
        const accessReference = U.getAccessReference();
        // options = this.setOptionsForNewGW(accessReference, options);
        redirectUrl = encodeURIComponent(redirectUrl);
        if (accessReference) {
            if (this.environment.environment === 'aaa') {
                const isDelivery = mUrl.indexOf(this.environment.GW_API) === 0;
                options = this.setOptionsForNewGW(accessReference, options, isDelivery);
            } else {
                options = this.setOptionsForNewGW(accessReference, options);
            }
            //have access_token make normal request
            return this.handleResponse(new DeleteRequest(this, mUrl), redirectUrl, options, isInfocert);
        } else {
            //not access-reference (no token) and not have the code from login page not accessed so redirect to login page
            this.loginRequest.loginCodeRequest(redirectUrl);
        }
    }

    private handleResponse(requestInterface: MRequest, redirectUrl: string, options?: RequestOptionsArgs, isInfocert: boolean = false): Observable<any> {
        
	    if (options && options.headers && options.headers.has('commodities')) {
		    options = this.manageMultipleCommoditiesHeaderIfNotSuperUser(options);
	    }
        return new Observable<Response>(observer => {
            requestInterface.doAction(options).subscribe(
                response => { //response OK
                    observer.next(response);
                    observer.complete();
                }, error => {//response KO
                    if (!isInfocert && error.status === 401 && error.json().code.includes('GATEWAY')) {
                        /**try to get new access_token from refresh_token**/
                        this.loginRequest.loginRefreshingTokenRequest().subscribe(
                            resp => {
                                const response = resp as Response;
                                if (response.ok) {  //response OK login-service setted accessReference
                                    //make normal request because sure to have token
                                    options = U.updateOptions(options);
                                    requestInterface.doAction(options).subscribe(
                                        res => {
                                            observer.next(res);
                                            observer.complete();
                                        }, err => {//response KO
                                            observer.next(err);
                                            observer.complete();
                                        });
                                } else {
                                    //response KO
                                    //TODO management other error
                                    this.loginRequest.loginCodeRequest(redirectUrl);
                                }
                            });
                    } else {
                        //TODO management other error
                        observer.next(error);
                        observer.complete();
                    }
                });
        });
    }


    private handleError(error: any): Promise<any> {
        try {
            console.error('An error occurred', error);
            
            return new Promise((resolve, reject) => {
                reject();
            });

        } catch (e) {
            console.error(e);
        }
    }

	private externalLoginFromTokenMetadata(tokenMetadata: string, mUrl: string, redirectUrl: string, options: RequestOptionsArgs): Observable<Response> {
		return this.loginRequest.externalLoginFromTokenMetadata(tokenMetadata).pipe(
			switchMap((resp: Response) => {
				if (resp) {
					options = U.updateOptions(options);
					return super.get(mUrl, options);
				} else {
					throw resp;
				}
			}),
			catchError(err => {
				this.loginRequest.loginCodeRequest(redirectUrl);
				return throwError(err);
			}));
	}

	getUserPermission(user_id: string): Observable<any> {
		const url: string = this.environment.PERMISSION_API + '/users/' + user_id + '?current=false';
		return this.get(url, this.environment.ROOT_REDIRECT, null).pipe(tap(resp => {
			if (resp.ok) {
				this.isSuperUser = (new UserPermissionsModel(resp.json()) as UserPermissionsModel).hasPermissions(SuperUserPermissions.super_user_can_read_all);
                //this.loggedUser = new UserPermissionsModel(resp.json()) as UserPermissionsModel;
			}
		}));
	}
/*
    get isSuperUser(): boolean {
        if(permissionService.currentProfileKey && this.loggedUser.hasPermissions(SuperUserPermissions.super_user_can_read_all)){
            return true
        }
        else return false;
    }*/

    private manageMultipleCommoditiesHeaderIfNotSuperUser(options: RequestOptionsArgs): RequestOptionsArgs {
		if (options.headers.get('commodities').split(',').length > 1) {
            // questo metodo si poteva anche evitare, visto che viene utilizzato solo qua
            let commodities = this.commoditiesUtilityService.manageMultiCommoditiesForHeader(this.isSuperUser, options.headers.get('commodities'));
            if(commodities){                                     
                options.headers.set('commodities', commodities); 
            } else {
                options.headers.delete('commodities');
            }
		}
		return options;
	}

	/*private deleteMultipleCommoditiesHeaderIfNotSuperUser(options: RequestOptionsArgs): RequestOptionsArgs {
		if (!this.isSuperUser && options.headers.get('commodities').split(',').length > 1) {
			options.headers.delete('commodities');
		}
		return options;
	}*/
}

export interface MRequest {
    doAction(options?: RequestOptionsArgs): Observable<any>;
}

export abstract class RequestWithBody implements MRequest {

    constructor(protected http: HttpAuthService,
        protected mUrl: string,
        protected body: any) { }

    abstract doAction(options?: RequestOptionsArgs): Observable<any>;
}

export class PostRequest extends RequestWithBody {

    doAction(options?: RequestOptionsArgs): Observable<any> {
        return this.http.superPost(this.mUrl, this.body, options);
    }
}


export class PutRequest extends RequestWithBody implements MRequest {

    doAction(options?: RequestOptionsArgs): Observable<any> {
        return this.http.superPut(this.mUrl, this.body, options);
    }
}

export class PatchRequest extends RequestWithBody implements MRequest {

    doAction(options?: RequestOptionsArgs): Observable<any> {
        return this.http.superPatch(this.mUrl, this.body, options);
    }
}

export abstract class RequestWithoutBody {

    constructor(protected http: HttpAuthService,
        protected mUrl: string) { }

    abstract doAction(options?: RequestOptionsArgs): Observable<any>;
}

export class GetRequest extends RequestWithoutBody {

    doAction(options?: RequestOptionsArgs): Observable<any> {
        return this.http.superGet(this.mUrl, options);
    }
}

export class DeleteRequest extends RequestWithoutBody {

    doAction(options?: RequestOptionsArgs): Observable<any> {
        return this.http.superDelete(this.mUrl, options);
    }
}
